import {
  LIST_SCORER_VERSIONS_ROUTE,
  CREATE_SCORER_VERSION_ROUTE,
  GET_SCORER_VERSION_ROUTE,
  ACTIVATE_SCORER_VERSION_ROUTE,
  RESTORE_SCORER_VERSION_ROUTE,
  DELETE_SCORER_VERSION_ROUTE,
  COMPARE_SCORER_VERSIONS_ROUTE,
} from '../../handlers/scorer-versions';
import {
  LIST_STORED_SCORERS_ROUTE,
  GET_STORED_SCORER_ROUTE,
  CREATE_STORED_SCORER_ROUTE,
  UPDATE_STORED_SCORER_ROUTE,
  DELETE_STORED_SCORER_ROUTE,
} from '../../handlers/stored-scorers';

export const STORED_SCORERS_ROUTES = [
  // Stored Scorers CRUD Routes
  LIST_STORED_SCORERS_ROUTE,
  GET_STORED_SCORER_ROUTE,
  CREATE_STORED_SCORER_ROUTE,
  UPDATE_STORED_SCORER_ROUTE,
  DELETE_STORED_SCORER_ROUTE,

  // Scorer Versions Routes
  // IMPORTANT: Routes with literal paths (e.g., /compare) must come BEFORE
  // routes with path parameters (e.g., /:versionId) to ensure correct matching.
  LIST_SCORER_VERSIONS_ROUTE,
  CREATE_SCORER_VERSION_ROUTE,
  COMPARE_SCORER_VERSIONS_ROUTE,
  GET_SCORER_VERSION_ROUTE,
  ACTIVATE_SCORER_VERSION_ROUTE,
  RESTORE_SCORER_VERSION_ROUTE,
  DELETE_SCORER_VERSION_ROUTE,
] as const;
